import { Reveal, SectionHeader } from "./Bits";

const COCKPIT_IMG =
  "https://images.pexels.com/photos/9592034/pexels-photo-9592034.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const MISSIONS = [
  {
    id: "OP-01",
    name: "NIGHTFALL",
    loc: "KOLWEZI CORRIDOR // DRC",
    obj: "EXFILTRATE DEFECTOR — ZERO ALARMS",
    threat: 3,
    status: "STANDBY",
  },
  {
    id: "OP-02",
    name: "BLACKOUT",
    loc: "SEVERODVINSK NAVAL YARD // RU",
    obj: "SEVER REACTOR UPLINK — 04:00 WINDOW",
    threat: 4,
    status: "LOCKED",
  },
  {
    id: "OP-03",
    name: "ZERO HOUR",
    loc: "[REDACTED]",
    obj: "[OBJECTIVE SEALED]",
    threat: 5,
    status: "EYES ONLY",
  },
];

const ThreatMeter = ({ level }) => (
  <div className="flex gap-1">
    {[1, 2, 3, 4, 5].map((i) => (
      <span key={i} className={`h-2 w-6 ${i <= level ? "bg-signal" : "bg-line"}`} />
    ))}
  </div>
);

export const Operations = () => (
  <section
    id="operations"
    data-testid="operations-section"
    className="relative overflow-hidden px-6 py-28 md:px-12 md:py-36"
  >
    <img
      src={COCKPIT_IMG}
      alt=""
      aria-hidden
      className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-[0.07] saturate-0"
    />
    <div className="relative mx-auto max-w-[1400px]">
      <SectionHeader
        index="03"
        label="OPERATIONS"
        title="Active Dossiers"
        desc="Three theatres. One operative. Windows are measured in minutes and consequences in decades."
      />
      <div className="border-t border-line">
        {MISSIONS.map((m, i) => (
          <Reveal key={m.id} delay={i * 0.08}>
            <div
              data-testid={`operation-row-${i}`}
              className="group grid grid-cols-12 items-center gap-4 border-b border-line py-7 transition-colors duration-150 hover:bg-[#121820] md:py-9"
            >
              <span className="col-span-2 font-mono text-[11px] tracking-[0.25em] text-slate-600 md:col-span-1">
                {m.id}
              </span>
              <h3 className="col-span-10 font-mono text-2xl font-extrabold uppercase tracking-tight text-[#F8FAFC] transition-colors group-hover:text-signal md:col-span-4 md:text-4xl">
                {m.name}
              </h3>
              <div className="col-span-8 font-mono text-[10px] leading-relaxed tracking-[0.2em] text-slate-500 md:col-span-4">
                <p>{m.loc}</p>
                <p className="mt-1 text-slate-400">{m.obj}</p>
              </div>
              <div className="col-span-4 flex flex-col items-end gap-2 md:col-span-3">
                <ThreatMeter level={m.threat} />
                <span
                  className={`font-mono text-[10px] tracking-[0.3em] ${
                    m.status === "STANDBY" ? "text-signal" : "text-slate-600"
                  }`}
                >
                  {m.status}
                </span>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2}>
        <p className="mt-8 font-mono text-[10px] tracking-[0.3em] text-slate-600">
          THREAT ASSESSMENT: 5 SEGMENTS // <span className="redacted">FAILURE IS DENIABLE</span>
        </p>
      </Reveal>
    </div>
  </section>
);
